// extracted by mini-css-extract-plugin
export default {"cta":"_G-z","disabled":"aH-z"};